import { IStoreState, IAuthState } from 'src/interface';

export const authSelector = (state: IStoreState): IAuthState => state.auth;

export const strUserIdSelector = (state: IStoreState): string => state.auth.strUserId;
export const isLoggedSelector = (state: IStoreState) => state.auth.userId > 0;
export const isFetchingSelector = (state: IStoreState) => state.auth.isFetching;
